import type { Infer } from 'superstruct';
import { literal, object, union } from 'superstruct';

export const DUPLICATE_ROLE_NAME = 'validations:Duplicate Role Name';

export const AddEditRoleErrorDto = union([
	object({
		message: literal(DUPLICATE_ROLE_NAME),
	}),
]);

export type AddEditRoleErrorDto = Infer<typeof AddEditRoleErrorDto>;
